import { MapObject } from '../../../models/mapObject';
import CityHallScreen from '../../../screens/CityHallScreen';
import type { ScreenType } from '../../../screens/cityHall/types';

interface MapStaticObjectModalProps {
  isOpen: boolean;
  staticObject: MapObject | null;
  onClose: () => void;
  initialScreen?: ScreenType;
}

export default function MapStaticObjectModal({ isOpen, staticObject, onClose, initialScreen }: MapStaticObjectModalProps) {
  if (!isOpen || staticObject?.type !== 'cityhall') {
    return null;
  }

  // Рендеримо CityHallScreen як модалку поверх мапи (вище election announcement z-10000).
  // key remounts when deep-link sets initialScreen after first open — avoids setState-in-effect.
  // Include object id so a null→vote_list flip remounts onto the correct hall, not a blank shell.
  return (
    <div className="fixed inset-0 z-[10050] bg-black-alpha-50">
      <CityHallScreen
        key={`${staticObject.id}-${initialScreen ?? "main"}`}
        onClose={onClose}
        mapObjectId={staticObject.id}
        initialScreen={initialScreen}
      />
    </div>
  );
}
